import { clip, clipToBox, clamp } from "./range.js";

const range = {
  clip,
  clipToBox,
  clamp
};

export default range;
